import './App.css';
import React from "react";
import { ConfigProvider } from './context/ConfigContext';
import LayoutV6PresetStandard from './layout/LayoutV6PresetStandard';  // Import the layout
import { ThemeProvider } from '@mui/material/styles';
import theme from './styles/theme';

function App() {
  return (
    <ConfigProvider initialYear="2025">
      <ThemeProvider theme={theme}>
        <LayoutV6PresetStandard>
        </LayoutV6PresetStandard>
      </ThemeProvider>
    </ConfigProvider>

  );
}

export default App;